export const THEMES = {
  default: "default",
  novatravel: "novatravel",
  asistour: "asistour",
  dartur: "dartur",
}
